var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "accordion", class: _vm.accordionClass },
    [
      _c(
        "a",
        {
          staticClass: "accordion__header",
          class: _vm.headerClass,
          attrs: { href: "#" },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.activate.apply(null, arguments)
            },
          },
        },
        [
          _vm.heading
            ? _c("span", [_vm._v(_vm._s(_vm.heading))])
            : _c("div", [_vm._t("header")], 2),
          _c("icon", {
            staticClass: "accordion__icon",
            attrs: { name: _vm.currentIcon, width: "13px", height: "13px" },
          }),
        ],
        1
      ),
      _c("transition", { attrs: { name: _vm.transition } }, [
        _vm.active
          ? _c(
              "div",
              {
                ref: "content",
                staticClass: "accordion__content",
                style: _vm.contentStyle,
              },
              [_vm._t("default")],
              2
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }